<template>
  <!-- formStatus 服务工单状态 0：未开始，10：进行中，20：已完成 30:已关闭 -->
  <!-- NodeStatus 节点状态，0：锁定，10：待审核，20：进行中，30：已完成 -->
  <!-- LockMode sop解锁模式：0：全开，10：全锁，20：依次解锁/闯关  -->
  <div v-if="loading" style="text-align: center; padding: 40px">
    <van-loading size="30px" type="spinner" vertical>加载中..</van-loading>
  </div>
  <div v-if="!loading && CourseList" id="box" class="my-post">
    <div class="top-nav flex">
      <a
        class="nav-left flex-1 title flex flex-align-center"
        href="javascript:;"
        @click="onClickLeft"
      >
        <div class="icon-box">
          <van-icon
            class="goback_icon"
            color="#ffffff"
            name="arrow-left"
            size="22px"
          />
        </div>
        <div class="product-name">{{ ProductName }}</div>
      </a>

      <a
        class="flex nav-right"
        :class="{ show: showPicker == true }"
        href="javascript:;"
        @click.prevent="showPicker = !showPicker"
      >
        <div class="text">目录</div>
        <div class="icon-menu">
          <span class="line"></span>
        </div>
      </a>
    </div>

    <van-popup
      v-model:show="showPicker"
      close-icon="close"
      :overlay-style="{ zIndex: 1022 }"
      position="right"
      :style="{ height: '100%', width: '80%', maxWidth: '400px', zIndex: 1023 }"
    >
      <ul class="tree-content">
        <li
          v-for="item in nodeTree"
          :key="item.NodeId"
          :class="{ 'show-children': item.showChild }"
        >
          <div
            class="title flex flex-align-center"
            @click="item.showChild = !item.showChild"
          >
            <i class="iconfont arrow">&#xe688;</i>
            <h2 class="flex-1">{{ item.NodeName }}</h2>
            <div v-if="item.NodeStatus === 0" class="status">
              <van-icon color="#999" name="lock" size="20px" />
            </div>
            <div v-if="item.NodeStatus === 30" class="status">
              <van-icon color="#20b759" name="checked" size="20px" />
            </div>
          </div>
          <div v-if="item.ChildNodes.length" class="children">
            <ul>
              <li
                v-for="item2 in item.ChildNodes"
                :key="item2.NodeId"
                :class="{
                  current: getCurrent(item2),
                  disabled: item2.NodeStatus === 0,
                }"
                @click="selectNode(item, item2)"
              >
                <div class="title flex flex-align-center">
                  <h2 class="flex-1">{{ item2.NodeName }}</h2>
                  <div v-if="item2.NodeStatus === 0" class="status">
                    <van-icon color="#999" name="lock" size="20px" />
                  </div>
                  <div v-if="item2.NodeStatus === 30" class="status">
                    <van-icon color="#20b759" name="checked" size="20px" />
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div v-else class="children no-data">
            <ul>
              <li>
                <div class="title flex flex-align-center">
                  <h2>无子节点</h2>
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </van-popup>
    <div v-if="CourseList" class="list-item">
      <van-empty
        v-if="!CourseList.length || NodeStatus == '0'"
        description="暂无模块"
        image-size="80"
      />

      <div
        v-for="(item, index) in CourseList"
        :id="'id' + item.ModuleInstanceId"
        :key="index + 'y'"
        class="list_box"
      >
        <!-- 定制交付  ---完成 后续待调整---->
        <Deliver
          v-if="item.ModuleCode == 'Custom' && NodeStatus != '0'"
          :deliver="item"
        />
        <!-- 课程视频    ---完成 图标待调整-->
        <CourseVideo
          v-if="item.ModuleCode == 'CourseVideo' && NodeStatus != '0'"
          :ind="index"
          :required="item.Required"
          :video="item"
        />
        <!-- 课程音频    ---完成 图标待调整-->
        <CourseVideo
          v-if="item.ModuleCode == 'CourseAudio' && NodeStatus != '0'"
          :required="item.Required"
          :video="item"
        />
        <!-- 课程文件   ---完成 图标待调整-->
        <File
          v-if="item.ModuleCode == 'CourseFile' && NodeStatus != '0'"
          :file="item"
        />
        <!-- 课堂互动  ---完成 后续待调整 -->
        <Interactive
          v-if="item.ModuleCode == 'Interaction' && NodeStatus != '0'"
          :interactive="item"
          :nodestatus="NodeStatus"
          :state1="FormStatus"
          @mm="getNodeModulesInfo"
        />
        <!-- 课后作业   ---完成-->
        <Operation
          v-if="item.ModuleCode == 'Homework' && NodeStatus != '0'"
          :nodestatus="NodeStatus"
          :operation="item"
          :state="FormStatus"
        />
        <!-- 服务评价  ---完成 -->
        <Evaluate
          v-if="item.ModuleCode == 'Comment' && NodeStatus != '0'"
          :evaluate="item"
          :nodestatus="NodeStatus"
          :pjdata="pjData"
          :state2="FormStatus"
        />
        <!-- 电话沟通 ---完成 后续待调整-->
        <Tel
          v-if="item.ModuleCode == 'PhoneCommunication' && NodeStatus != '0'"
          :tel="item"
        />
        <!-- 学员案例 ---完成 后续待调整 -->
        <CollegCase
          v-if="item.ModuleCode == 'Case' && NodeStatus != '0'"
          :xycase="item"
        />
        <!-- 演示Url ---完成 后续待调整-->
        <DeomUrl
          v-if="item.ModuleCode == 'Url' && NodeStatus != '0'"
          :url="item"
        />
        <!-- 图片 ---完成 后续待调-->
        <Photo
          v-if="item.ModuleCode == 'Image' && NodeStatus != '0'"
          :photo="item"
        />
        <!-- 文本框  ---完成 -->
        <TextBox
          v-if="item.ModuleCode == 'Text' && NodeStatus != '0'"
          :text="item"
        />
        <!-- 结业证书  ---完成 后续待调-->
        <Certificate
          v-if="item.ModuleCode == 'Certificate' && NodeStatus != '0'"
          :ficate="item"
        />
        <!-- 结业证书  ---完成 后续待调-->
        <Survey
          v-if="item.ModuleCode == 'ConsultationSheet' && NodeStatus != '0'"
          :data="item"
          :node-status="NodeStatus"
        />
        <!-- 客户收集  ---完成 后续待调-->
        <CustomerCollection
          v-if="item.ModuleCode == 'CustomerCollection' && NodeStatus != '0'"
          :data="item"
        />
      </div>
      <!-- formStatus 服务工单状态 0：未开始，10：进行中，20：已完成 30:已关闭 -->
      <!-- NodeStatus 节点状态，0：锁定，10：待审核，20：进行中，30：已完成 -->
      <!-- LockMode sop解锁模式：0：全开，10：全锁，20：依次解锁  -->
      <van-tabbar v-if="selectList.length" class="van-tabbar">
        <div class="flex flex-align-center toolbar-box">
          <div class="title flex-1">
            <van-notice-bar
              background="#f9f9f9"
              color="#666"
              :scrollable="
                selectList[selectList.length - 1].NodeName.length > 9
                  ? true
                  : false
              "
              :text="'当前课程：' + selectList[selectList.length - 1].NodeName"
            />
          </div>
          <van-button
            v-if="getShowBtn.showBtn"
            color="#b57e48"
            :loading="finishNodeLoading"
            loading-text="请稍后"
            size="small"
            @click="SOPMenteeFinishNode(selectList)"
          >
            {{ getShowBtn.text }}
          </van-button>
        </div>
      </van-tabbar>
    </div>
  </div>
</template>
<script>
  //import ArticleList from '@/components/ArticleList'
  import Deliver from './components/deliver' //定制交付
  import CourseVideo from './components/video' //课程视频
  import Audio from './components/Audio.vue'
  import File from './components/file' //课程文件 -----（完成）
  import Interactive from './components/interactive' //课堂互动
  import Operation from './components/operation' //课后作业
  import Evaluate from './components/evaluate' //服务评价
  import Tel from './components/oneTel' //电话沟通
  import CollegCase from './components/collegeCase' //学员案例-----（完成）
  import DeomUrl from './components/deomUrl' //演示URL-----（完成）
  import Photo from './components/photo' //图片-----（完成）
  import TextBox from './components/textBox' //文本框-----（完成）
  import Certificate from './components/Certificate' //结业证书（完成）
  import Survey from './components/Survey'
  import CustomerCollection from './components/CustomerCollection'
  import { useRoute, useRouter } from 'vue-router'
  import { Toast, Dialog, Notify } from 'vant'
  import { wxShare } from '@/utils/index'
  import {
    ref,
    onActivated,
    onDeactivated,
    onMounted,
    toRaw,
    onUnmounted,
    onBeforeUnmount,
    watch,
    computed,
  } from 'vue'
  // import { useRouter } from 'vue-router'
  import store from '@/store'
  import api from '@/api'
  import storage from '@/utils/storage'
  export default {
    name: 'ServiceContent',
    components: {
      Deliver,
      CourseVideo,
      CustomerCollection,
      File,
      Interactive,
      Operation,
      Evaluate,
      Tel,
      CollegCase,
      DeomUrl,
      Photo,
      TextBox,
      Certificate,
      //Audio,
      Survey,
    },
    setup() {
      //处理后的数组
      const newArrList = ref([])
      const route = useRoute()
      const active = ref(1)
      const istrue = ref(false)
      const tenant = ref('')
      const NodeStatus = ref(null)
      const finishNodeLoading = ref(false)
      const loading = ref(false)
      let url = ref('')
      let tit = ref('')
      let FormStatus = ref(null)
      const params = ref({})
      //const userInfo = ref({})
      const ProductName = ref('')
      const pjData = ref({})
      const isPreview = ref(route.query.preview)
      const router = useRouter()
      // sopinfo
      let sopInfo = ref({})
      //级联选择器
      const nodeTree = ref([])
      //自定义名称
      const customFieldName = {
        text: 'NodeName',
        children: 'ChildNodes',
      }
      //const result = ref([])
      //模块数据
      const CourseList = ref([])
      const showPicker = ref(false)

      // 初始化选中的课和
      const selectList = ref([])
      const defaultIndex = ref(0)

      onActivated(() => {
        init()
      })
      const init = async () => {
        loading.value = true
        const formId = route.params.id
        if (!formId) return
        let url = await store.getters['system/getH5Url']
        url += `home/#/pagesService/classroom/classroom?formId=${formId}`
        location.href = url

        selectList.value = []
        CourseList.value = []
        //await checkAndFinishForm(formId)
        await getSopFormSimpleInfo(formId) //获取详情
        //获取课程章节
        await getSopNodeTree()
        initSelectList(nodeTree.value)
        getNodeModulesInfo()
        initWxShare()
        setTimeout(() => {
          RecordNodeStayDuration()
          loading.value = false
        }, 300)
      }
      const initWxShare = async () => {
        const tenant = await store.getters['user/getTenant']
        let desc = `《${sopInfo.value.ProductName}》的`
        const node = selectList.value[selectList.value.length - 1]
        if (node) {
          desc += `${node.NodeName}`
        }

        desc += '太精彩了，快来看看吧！'
        let url = await store.getters['system/getH5Url']
        url += `service/#/service/share?formId=${sopInfo.value.FormId}`
        // let url = 'http://wx.hanson.com/'
        // url += `#/service/share?formId=${sopInfo.value.FormId}`
        const userInfo = await store.getters['user/getUserInfo']
        url += `&channelId=${userInfo.UserId}`
        if (node) {
          url += `&nodeId=${node.NodeId}`
        }
        console.log(url)
        wxShare(tenant.TenantName, desc, null, url)
      }

      // 获取是否显示底部完成按钮
      const getShowBtn = computed(() => {
        let res = { showBtn: false, text: '' }
        const sop = sopInfo.value
        const selectItem = selectList.value.length
          ? selectList.value[selectList.value.length - 1]
          : null
        const selectPrentItem = selectList.value[0]

        if (sop && selectItem && sop.FormStatus === 10) {
          if (
            selectItem.NodeStatus === 20 &&
            (sop.LockMode === 0 || sop.LockMode === 20)
          ) {
            res.showBtn = true
            res.text =
              selectPrentItem.last && selectItem.last
                ? '完成本节课'
                : '学习下节课'
          }
          if (selectItem.NodeStatus === 30 && sop.LockMode === 0) {
            res.showBtn = true
            res.text = '重学本节课'
          }
        }
        return res
      })

      /**
       * 上报学习时长
       * @date 2022-09-26
       * @returns {any}
       */
      let timer = null
      let times = 1
      const RecordNodeStayDuration = () => {
        const info = sopInfo.value
        if (info.FormStatus === 0 || info.FormStatus === 30) {
          return
        }
        if (times >= 15) {
          setRecordNodeStayDuration()
        }
        timer = setTimeout(() => {
          times++
          RecordNodeStayDuration()
        }, 1000)
      }

      const setRecordNodeStayDuration = () => {
        if (!selectList.value.length) return
        store
          .dispatch('service/RecordNodeStayDuration', {
            formId: sopInfo.value.FormId,
            nodeId: selectList.value[selectList.value.length - 1].NodeId,
            duration: times,
          })
          .then((data) => {})
        times = 0
      }

      onBeforeUnmount(() => {
        setRecordNodeStayDuration()
        clearTimeout(timer)
      })

      onDeactivated(() => {
        isInit = false
        setRecordNodeStayDuration()
        clearTimeout(timer)
      })
      // 上报end

      /**
       * 获取课程节点
       * @author hanson.liu
       * @date 2022-08-03
       * @param {any} Id 课程主id
       * @returns {any}
       */
      const getSopNodeTree = (Id) => {
        const id = route.params.id
        return new Promise((resolve, reject) => {
          store
            .dispatch('service/GetSopNodeTree', {
              formId: id,
              IsMentee: true,
            })
            .then((res) => {
              if (res.Code === 0) {
                res.Data.map((item, index) => {
                  //console.log(item, selectList)
                  if (item.NodeStatus === 0) {
                    item.disabled = true
                  }
                  if (res.Data.length === index + 1) {
                    item.last = true
                  }
                  if (
                    selectList.value.length &&
                    selectList.value[0].NodeId === item.NodeId
                  ) {
                    item.showChild = true
                  } else {
                    item.showChild = false
                  }
                  item.ChildNodes.map((item2, index2) => {
                    if (item2.NodeStatus === 0) {
                      item2.disabled = true
                    }
                    if (item.ChildNodes.length === index2 + 1) {
                      item2.last = true
                    }
                  })
                })
                nodeTree.value = res.Data
              }
              resolve()
            })
            .catch((e) => {
              Toast(e.Message || '操作失败')
              reject(e)
            })
        })
      }

      /**
       * 初始化选中节点（章节） 如果url query带了NodeId 则不从缓存拿取
       * @author hanson.liu
       * @date 2022-08-16
       * @param {any} list
       * @returns {any}
       */
      const initSelectList = (list) => {
        const nodeId = route.query.nodeId
        // 如果url query带了NodeId 则不从缓存拿取
        const hasSelectId = nodeId ? nodeId : getStorageNodeId()
        list.defaultIndex = 1
        for (let i = 0, len = list.length; i < len; i++) {
          const item = list[i]
          let isSetChild = null
          for (let j = 0, len = item.ChildNodes.length; j < len; j++) {
            const item2 = item.ChildNodes[j]
            if (hasSelectId && item2.NodeId === hasSelectId) {
              isSetChild = item2
              break
            }
            if (!hasSelectId && item2.NodeStatus == 20) {
              isSetChild = item2
              setStorageNodeId(item2.NodeId)
              break
            }
          }
          if (isSetChild) {
            item.showChild = true
            selectList.value = [item, isSetChild]
            break
          }
        }
      }
      const getStorageNodeId = () => {
        let res = ''
        const id = route.params.id
        res = storage.get('service' + id)
        return res
      }

      const setStorageNodeId = (val) => {
        const id = route.params.id
        storage.set('service' + id, val)
      }

      // 章节列表
      // watch(nodeTree, () => {
      //   // 初始化设置选中item
      //   initSelectList(nodeTree.value)
      //   getNodeModulesInfo()
      // })

      //获取详情
      const getSopFormSimpleInfo = (id) => {
        return store
          .dispatch('service/GetSopFormSimpleInfo', { formId: id })
          .then((res) => {
            if (res.Code === 0) {
              ProductName.value = res.Data.ProductName
              FormStatus.value = res.Data.FormStatus
              sopInfo.value = res.Data
            }
          })
      }
      /**
       * 获取本节课堂内容
       * @author hanson.liu
       * @date 2022-08-03
       * @returns {any}
       */
      let isInit = false
      const getNodeModulesInfo = () => {
        const list = selectList.value
        const formId = sopInfo.value.FormId
        if (!selectList.value.length) return
        NodeStatus.value = list[list.length - 1].NodeStatus
        let newList = []
        store
          .dispatch('service/GetNodeModulesInfo', {
            NodeId: list[list.length - 1].NodeId,
            IsMentee: true,
            formId,
          })
          .then((res) => {
            if (res.Code === 0) {
              for (let item in res.Data) {
                res.Data[item].forEach((item2) => {
                  if (
                    item2.ModuleCode == 'Image' ||
                    item2.ModuleCode == 'CourseVideo' ||
                    item2.ModuleCode == 'CourseAudio' ||
                    item2.ModuleCode == 'CourseFile'
                  ) {
                    if (item2.Materials && item2.Materials.length > 0) {
                      newList.push(item2)
                    }
                  } else if (item2.ModuleCode == 'Text') {
                    if (item2.Content && item2.Content != null) {
                      newList.push(item2)
                    }
                  } else if (item2.ModuleCode == 'Url') {
                    if (item2.Content && item2.Content != null) {
                      newList.push(item2)
                    }
                  } else if (item2.ModuleCode == 'Case') {
                    if (item2.Cases && item2.Cases.length > 0) {
                      newList.push(item2)
                    }
                  } else if (item2.ModuleCode == 'Interaction') {
                    newList.push(item2)
                  } else if (
                    item2.ModuleCode == 'Certificate' ||
                    item2.ModuleCode == 'Custom'
                  ) {
                    if (item2.Deliveries && item2.Deliveries.length > 0) {
                      newList.push(item2)
                    }
                  } else if (item2.ModuleCode == 'Comment') {
                    newList.push(item2)
                  } else if (item2.ModuleCode == 'PhoneCommunication') {
                    if (
                      item2.FailedBookings.length ||
                      item2.SuccessfulBookings.length ||
                      item2.Bookings.length
                    ) {
                      newList.push(item2)
                    }
                  } else if (item2.ModuleCode == 'Homework') {
                    if (item2.Subjects && item2.Subjects.length > 0) {
                      newList.push(item2)
                    }
                  } else if (item2.ModuleCode == 'ConsultationSheet') {
                    if (item2.DispatchId && item2.DispatchId != '0')
                      newList.push(item2)
                  } else {
                    newList.push(item2)
                  }
                })
                //newList.push(...res.Data[item])
              }
              newList.sort(function (a, b) {
                let x = a['Sort']
                let y = b['Sort']
                return x < y ? -1 : x > y ? 1 : 0
              })
              // console.log(newList)
              CourseList.value = newList
              //console.log('CourseList.value :>> ', CourseList.value)

              // 切换时先进行上报
              if (isInit) setRecordNodeStayDuration()
              isInit = true
            }
          })
          .catch((e) => {
            Toast(e.Message)
          })
        // }
      }

      /**
       * 完成或重学本节课
       * @author hanson.liu
       * @date 2022-08-03
       * @param {any} selectList
       * @returns {any}
       */
      const SOPMenteeFinishNode = async (selectList) => {
        const selectItem = selectList[selectList.length - 1]
        const nodeId = selectItem.NodeId
        const formId = sopInfo.value.FormId
        finishNodeLoading.value = true
        let url = 'service/SOPMenteeFinishNode'
        if (selectItem.NodeStatus === 30) {
          url = 'service/SOPMenteeRestartNode'
        }
        await checkCanSubmit(selectItem.NodeStatus)
          .then((data) => {
            store
              .dispatch(url, { nodeId, formId })
              .then(async (data) => {
                await getSopNodeTree()

                if (selectItem.NodeStatus === 20) {
                  nextNode(finishNodeLoading)
                } else {
                  Toast('操作成功')
                  finishNodeLoading.value = false
                  init()
                }
              })
              .catch((e) => {
                setTimeout(() => {
                  finishNodeLoading.value = false
                }, 500)
                Toast(e.Message || '操作失败')
              })
          })
          .catch((data) => {
            const { res, msg } = data
            Toast(msg)
            finishNodeLoading.value = false
            document
              .querySelector('#id' + res[0].ModuleInstanceId)
              .scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest',
              })
          })
      }

      /**
       * 检查是否可以提交
       * @author hanson.liu
       * @date 2022-08-18
       * @param {any} NodeStatus
       * @returns {any}
       */
      const checkCanSubmit = (NodeStatus) => {
        // console.log(sopInfo.value)
        return new Promise((resolve, reject) => {
          if (NodeStatus === 30) {
            resolve()
            return
          }
          const list = CourseList.value
          let canSubmit = true
          let msg = ''
          const res = []
          for (let index = 0; index < list.length; index++) {
            const item = list[index]
            if (
              item.ModuleCode === 'Homework' &&
              item.Required &&
              sopInfo.value.LockMode === 20
            ) {
              let IsSubmitted = true
              for (let j = 0; j < item.Subjects.length; j++) {
                const item2 = item.Subjects[j]
                if (!item2.IsSubmitted) {
                  IsSubmitted = false
                  break
                }
              }
              if (!IsSubmitted) {
                canSubmit = false
                msg = '存在未填写的作业，请填写'
                res.push(item)
                break
              }
            }

            if (
              (item.ModuleCode === 'CourseVideo' ||
                item.ModuleCode === 'CourseAudio') &&
              item.Required
            ) {
              let IsCompleted = true
              let resItem = null
              for (let j = 0; j < item.Materials.length; j++) {
                const item2 = item.Materials[j]
                if (!item2.Completed) {
                  IsCompleted = false
                  resItem = item2
                  break
                }
              }
              if (!IsCompleted) {
                canSubmit = false
                msg = `请先学完【${resItem.MaterialName}】`
                res.push(item)
                break
              }
            }

            if (
              item.ModuleCode === 'ConsultationSheet' &&
              item.Required &&
              item.ResultId === '0' &&
              !item.FilledBefore && // 同一份问卷没有在其它地方填写过
              sopInfo.value.LockMode === 20
            ) {
              canSubmit = false
              msg = '请填写' + item.DispatchName
              res.push(item)
              break
            }
          }
          if (canSubmit) {
            resolve()
          } else {
            reject({ res, msg })
          }
        })
      }

      /**
       * 进入下一节课
       * @author hanson.liu
       * @date 2022-08-03
       * @returns {any}
       */
      const nextNode = (finishNodeLoading) => {
        const list = selectList.value
        let next = []
        nodeTree.value.forEach((item, index) => {
          if (item.NodeId === list[0].NodeId) {
            item.ChildNodes.forEach((item2, index2) => {
              if (
                item2.NodeId === list[1].NodeId &&
                item.ChildNodes[index2 + 1]
              ) {
                next.push(item.ChildNodes[index2 + 1])
              }
            })
            // 说明当前节点在同级有下一课
            if (next.length) {
              next.unshift(item)
              // 如果没有则下一级找
            } else {
              if (
                nodeTree.value[index + 1] &&
                nodeTree.value[index + 1].ChildNodes &&
                nodeTree.value[index + 1].ChildNodes[0]
              ) {
                nodeTree.value[index + 1].showChild = true
                next = [
                  nodeTree.value[index + 1],
                  nodeTree.value[index + 1].ChildNodes[0],
                ]
              }
            }
          }
        })
        // 存在节点  且节点不为锁定/待审核状态
        if (
          next.length === 2 &&
          next[1].NodeStatus != 0 &&
          next[1].NodeStatus != 10
        ) {
          Toast('操作成功，正进入下一节课')
          setTimeout(() => {
            finishNodeLoading.value = false
            selectNode(next[0], next[1])
          }, 2000)
        } else {
          finishNodeLoading.value = false
          Toast('操作成功')
          init()
        }
      }

      watch(CourseList, () => {
        //console.log('CourseList :>> ')
        if (CourseList.value) {
          CourseList.value.map((item, index) => {
            //console.log('item :>> ', item)
            //如果為視頻文件
            if (
              item &&
              (item.ModuleCode == 'CourseVideo' ||
                item.ModuleCode == 'CourseAudio')
            ) {
              item.isShow = true
              item.lbIndex = 0
              let length = item.Materials.length
              if (length > 0) {
                item.Materials.map((item2, index2) => {
                  store
                    .dispatch('service/ShowAssetDetail', {
                      AssetId: item2.AssetId,
                    })
                    .then((res) => {
                      if (res.Code === 0) {
                        const { Data } = res
                        item2.Asset = Data
                      }
                    })
                })
              }
              //item.Materials.splice(0, length)
            }
          })
        }
      })

      const onClickLeft = () => {
        router.back()
        //localStorage.removeItem('resultVal')
      }

      /**
       * 选择节点
       * @author hanson.liu
       * @date 2022-08-03
       * @param {any} parentItem
       * @param {any} item
       * @returns {any}
       */
      const selectNode = (parentItem, item) => {
        if (item.NodeStatus === 0) {
          Toast('节点未解锁')
          return
        }
        const list = [parentItem, item]
        showPicker.value = false
        selectList.value = list
        // 存储缓存内容
        setStorageNodeId(list[list.length - 1].NodeId)
        // 获取节点内容
        getNodeModulesInfo()
        // 更新节点后更新分享内容
        initWxShare()
      }
      const handleSol = (e) => {}
      const getCurrent = (item) => {
        let res = false
        const list = selectList.value
        if (list.length) {
          if (item.NodeId === list[list.length - 1].NodeId) {
            res = true
          }
        }
        return res
      }
      //PostSelectByAuthor
      return {
        url,
        params,
        active,
        // userInfo,
        api,
        isPreview,
        nodeTree,
        selectNode,
        showPicker,
        NodeStatus,
        handleSol,
        istrue,
        onClickLeft,
        customFieldName,
        CourseList,
        tit,
        //getList,
        tenant,
        pjData,
        FormStatus,
        getSopFormSimpleInfo,
        ProductName,
        sopInfo,
        SOPMenteeFinishNode,
        selectList,
        defaultIndex,
        getCurrent,
        finishNodeLoading,
        getShowBtn,
        getNodeModulesInfo,
        loading,
      }
    },
  }
</script>
<style lang="scss" scoped>
  .my-post {
    padding: 44px 0 10px;
    height: 100%;
    background-color: #fff !important;
    &.nopd {
      padding-top: 0;
    }

    .list-item {
      padding: 0 12px;
    }
    .btn-box {
      width: 100%;
    }
  }
  .toolbar-box {
    width: 100%;
    line-height: 44px;
    height: 44px;
    overflow: hidden;
    padding: 3px 10px;

    .title {
      font-size: 16px;
      span {
        font-size: 14px;
        color: #666;
      }
    }
  }

  .van-tabbar {
    background: #f9f9f9;
    box-shadow: 0 0 3px rgba($color: #000000, $alpha: 0.15);
    .van-notice-bar {
      padding: 0 10px 0;
      font-size: 15px;
    }
  }
</style>
